import { createContext } from 'react';
import type { TProjectsContextValue } from './Projects.types.ts';

export const ProjectsContext = createContext<TProjectsContextValue | undefined>(
  undefined,
);
